export default __webpack_public_path__ + "static/media/web3-logo.76ac463b.svg";